export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-1200-affd828aa03a5d7c3fe36ee5d5cd8ca9.webp";